import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { Button } from '../ui/Button';
export function IncludesSection() {
  const scrollToCheckout = () => {
    document.getElementById('cta-box')?.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  };
  const items = ['Plan de implementación "48 horas"', 'Plantillas imprimibles de medicación (lista maestra + cambios + control semanal)', 'Plantillas de turnos (pre, durante, post)', 'Checklist de documentación mínima', 'Carpeta de emergencia (contactos + guión de llamada + checklist de bolso)', 'Ficha de Guardia diaria (la clave para delegar)', 'Registro Diario de 3 minutos', 'Mantenimiento semanal de 20 minutos'];
  return <section className="w-full bg-stone-100 py-16 md:py-24 px-4" data-id="element-129">
      <div className="max-w-3xl mx-auto" data-id="element-130">
        <h2 className="text-3xl font-serif font-bold text-stone-900 mb-10 text-center" data-id="element-131">
          Qué incluye el kit
        </h2>

        <div className="bg-white rounded-2xl p-8 md:p-10 shadow-sm" data-id="element-132">
          <ul className="space-y-4" data-id="element-133">
            {items.map((item, i) => <li key={i} className="flex items-start" data-id="element-134">
                <CheckCircle2 className="w-6 h-6 text-emerald-600 mr-4 flex-shrink-0 mt-0.5" data-id="element-135" />
                <span className="text-lg text-stone-700" data-id="element-136">{item}</span>
              </li>)}
          </ul>
        </div>

        <div className="mt-12 text-center" data-id="element-137">
          <p className="text-stone-600 mb-4 text-lg" data-id="element-138">
            Todo listo para imprimir y usar desde hoy.
          </p>
          <div className="mb-6" data-id="element-139">
            <span className="text-4xl md:text-5xl font-bold text-stone-900" data-id="element-140">
              $9.300
            </span>
            <span className="text-stone-500 ml-2" data-id="element-141">ARS</span>
            <span className="ml-3 inline-block bg-emerald-100 text-emerald-800 text-sm font-medium px-3 py-1 rounded-full" data-id="element-142">
              Precio promocional
            </span>
          </div>
          <Button size="lg" withIcon onClick={scrollToCheckout} className="bg-emerald-600 hover:bg-emerald-700 text-white border-0" data-id="element-143">
            Obtener Cuidador Sin Caos
          </Button>
          <p className="mt-4 text-sm text-stone-500" data-id="element-144">
            Descarga inmediata • Acceso de por vida
          </p>
        </div>
      </div>
    </section>;
}